import PrismicLink from '@components/PrismicLink';
import { IFooterCards } from '@context/LayoutContext/types';
import HyperLink from '@monofront/design-system/components/HyperLink';

interface IFooterCardProps {
  slice: IFooterCards;
  children?: React.ReactNode;
}

const FooterCard: React.FC<IFooterCardProps> = ({ children, slice }) => {
  if (!slice || !slice.primary) {
    return null;
  }

  const { title, description, ctaLabel, ctaLink, trackingId } = slice.primary;

  return (
    <>
      <div className="footer-card">
        {title && <h3 className="accent-title">{title}</h3>}
        {description && <p className="description">{description}</p>}

        {children}

        {ctaLabel && ctaLink && (
          <PrismicLink link={ctaLink} trackingId={trackingId || undefined}>
            <HyperLink variant="button-secondary-span">{ctaLabel}</HyperLink>
          </PrismicLink>
        )}
      </div>
      <style jsx>{`
        .footer-card {
          border-radius: var(--rd-3);
          background: var(--white);
          text-align: center;
          padding: var(--space-5);
        }
        .footer-card h3 {
          margin-bottom: var(--space-2);
        }
        .footer-card .description {
          margin-bottom: var(--space-3);
        }
        .footer-card :global(a span) {
          display: inline-flex;
        }
      `}</style>
    </>
  );
};

export default FooterCard;
